import { DefaultTheme, ThemeProvider } from "expo-router";
import { StatusBar } from "expo-status-bar";
import type { ReactNode } from "react";
import { useColorSchemeOverride } from "@/client/ui/hooks/useColorSchemeOverride";
import { View } from "@/client/ui/View";
import { VisualViewportCssVariables } from "./VisualViewportCssVariables";
import { Theme } from "./Theme";

export function PylyThemeProvider({ children }: { children: ReactNode }) {
  const { colorScheme } = useColorSchemeOverride();

  return (
    <ThemeProvider
      // Even though this looks like an no-op layout—it's not, and it ensures the
      // top and bottom of the app have the correct color.
      value={{
        dark: colorScheme === `dark`,
        colors: {
          background: `transparent`,
          // We should never see these colors, instead tamagui should
          // have priority.
          border: BUG_DETECTOR_COLOR,
          card: BUG_DETECTOR_COLOR,
          notification: BUG_DETECTOR_COLOR,
          primary: BUG_DETECTOR_COLOR,
          text: BUG_DETECTOR_COLOR,
        },
        fonts: DefaultTheme.fonts,
      }}
    >
      <Theme theme={colorScheme}>
        <View className="flex-1 bg-bg">
          <StatusBar style={colorScheme === `dark` ? `light` : `dark`} />
          {children}
          <VisualViewportCssVariables />
        </View>
      </Theme>
    </ThemeProvider>
  );
}

const BUG_DETECTOR_COLOR = `#ff0000`;
